import { lazy } from 'react';

export const TermsNlDigitalModalLazy = lazy(() =>
  import('./TermsNlDigitalModal').then((m) => ({ default: m.TermsNlDigitalModal })),
);
